import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../shared-module/seguridad/services/auth.guard';
import { MantenerJerarquiaEssencialComponent } from './view/mantener-jerarquia-essencial/mantener-jerarquia-essencial.component';
import { CsvValidarEssencialComponent } from './view/csv-validar-essencial/csv-validar-essencial.component';
import { MantenerGrupoVendedoresB2CComponent } from './view/mantener-grupo-vendedores-b2-c/mantener-grupo-vendedores-b2-c.component';


const logisticaRoutes: Routes = [
  { path: 'essencial/crear-jerarquia', component: MantenerJerarquiaEssencialComponent, canActivate: [AuthGuard]},
  { path: 'essencial/validador-jerarquia', component: CsvValidarEssencialComponent, canActivate: [AuthGuard]},
  { path: 'essencial/relacion-grupoSubcanal', component: MantenerGrupoVendedoresB2CComponent, canActivate: [AuthGuard]},
  
];

@NgModule({
  imports: [RouterModule.forChild(logisticaRoutes)],
  exports: [RouterModule]
})
export class EssencialRoutingModule { }